module.exports = function(){ /* empty */ };


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/$.add-to-unscopables.js
// module id = 855
// module chunks = 0